var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-products client-page"},[(_vm.showAccountStatus)?_c('AccountStatus'):_vm._e(),(!_vm.showAccountStatus)?_c('Parts'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }